import { gettext } from '@eventbrite/i18n';
import { MagnifyingGlassIcon, Typography } from '@eventbrite/marmalade';
import loadable from '@loadable/component';
import React, { useState } from 'react';
import { useGlobalNavContext } from '../../../../state';
import {
    getHeapDataAttribute,
    HeapAttributes,
} from '../../../../utils/heap-data';
import styles from './SearchBar.module.scss';

const LazySearchTakeover = loadable.lib(
    () => import('@eventbrite/search-takeover'),
);

const SearchBar = () => {
    const { Teams, Features, Components, Actions } = HeapAttributes;

    const { searchBar } = useGlobalNavContext();

    const [showSearch, setShowSearch] = useState(false);

    const handleClick = () => {
        setShowSearch(true);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            setShowSearch(true);
        }
    };

    function handleClose() {
        setShowSearch(false);
    }

    return (
        <>
            {searchBar?.renderSearchBar ? (
                <button
                    className={styles.main}
                    data-testid="header-search"
                    onClick={handleClick}
                    onKeyDown={handleKeyDown}
                    aria-label={gettext('open search bar').toString()}
                    data-heap-id={getHeapDataAttribute({
                        team: Teams.SEO,
                        feature: Features.GlobalNav,
                        component: Components.SearchBar,
                        name: 'search-bar',
                        action: Actions.Click,
                    })}
                >
                    <>
                        <Typography
                            variant="body-md"
                            as="span"
                            color="neutral-700"
                            className={styles.content}
                        >
                            <MagnifyingGlassIcon size="small" />
                            <span className={styles.desktopLabel}>
                                {searchBar?.desktopLabel}
                            </span>
                            <span className={styles.mobileLabel}>
                                {searchBar?.mobileLabel}
                            </span>
                        </Typography>

                        <LazySearchTakeover data-testid="search-takeover">
                            {({ SearchTakeover }: { SearchTakeover: any }) => (
                                <SearchTakeover
                                    domNodeId="root"
                                    onClose={handleClose}
                                    isVisible={showSearch}
                                    id="search-takeover"
                                />
                            )}
                        </LazySearchTakeover>
                    </>
                </button>
            ) : undefined}
        </>
    );
};

export default SearchBar;
